import { Objective } from './FormObjectives'
import { parseLabel } from 'app/views/forms/parseLabel'

export const FormObjectivesPrint = ({ title, value }) => {
  const parsedTitle = parseLabel(title)

  return (
    <div style={{ width: '100%' }}>
      <div className='form-read-only-header'>{parsedTitle}</div>
      {value?.map((data, index) => {
        return <Objective key={index} data={data} index={index} />
      })}
    </div>
  )
}
